export const Project = `
<path d="M538.947 269.474L269.474 0L0 269.474L269.474 538.947L538.947 269.474Z" transform="translate(485.053)"/>
<path d="M0 431.158H431.158V0H0V431.158Z" transform="translate(0 53.8947)"/>
<path d="M0 431.158H431.158V0H0V431.158Z" transform="translate(538.947 592.842)"/>
<path d="M0 431.158H431.158V0H0V431.158Z" transform="translate(0 592.842)"/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/project.js